<div>
  <p class="p1">
    {{ 'History: ' | trans:'customers/customer-details-modal/logs/history.Label' }}
  </p>

  <div class="m-t-16">
    @if (isLoading()) {
      <div class="d-flex justify-content-center">
        <app-loader />
      </div>
    } @else {
      <table class="base-2">
        <thead>
        <tr class="text-right">
          <th>
            {{ 'Date' | trans:'customers/customer-details-modal/logs/date.Label' }}
          </th>
          <th>
            {{ 'Application' | trans:'customers/customer-details-modal/logs/application.Label' }}
          </th>
          <th>
            {{ 'Action' | trans:'customers/customer-details-modal/logs/action.Label' }}
          </th>
          <th>
            {{ 'Transaction number' | trans:'customers/customer-details-modal/logs/transaction-number.Label' }}
          </th>
          <th>
            {{ 'Authorization numbner' | trans:'customers/customer-details-modal/logs/authorization-number.Label' }}
          </th>
          <th>
            {{ 'Issuer' | trans:'customers/customer-details-modal/logs/issuer.Label' }}
          </th>
        </tr>
        </thead>
        <tbody>
          @for (log of data; track log) {
            <tr class="text-right">
              <td>
                {{ log.logDate | localeDateFormat }}<br>
                {{ log.logDate | timeFormat }}
              </td>
              <td>
                {{ log.application | empty }}
              </td>
              <td>
                {{ log.action | empty }}
              </td>
              <td>
                {{ log.transactionNumber | empty }}
              </td>
              <td>
                {{ log.authorizationNumber | empty }}
              </td>
              <td>
                {{ log.distributor | empty }}
              </td>
            </tr>
          }
        </tbody>
      </table>
    }
  </div>
</div>
